import { render, staticRenderFns } from "./CreateAbandonmentReportsModal.vue?vue&type=template&id=23ae93a4&scoped=true&lang=pug"
import script from "./CreateAbandonmentReportsModal.vue?vue&type=script&lang=js"
export * from "./CreateAbandonmentReportsModal.vue?vue&type=script&lang=js"
import style0 from "./CreateAbandonmentReportsModal.vue?vue&type=style&index=0&id=23ae93a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ae93a4",
  null
  
)

export default component.exports